<template>
    <div>
        <div class="navbar-container">
            <el-menu class="navbar-menu" :mode="isMobile ? 'vertical' : 'horizontal'" :default-active="activeIndex"
                background-color="#ffffff" text-color="#333333" active-text-color="#2563eb" @select="handleNavigation">
                <div class="navbar-left">
                    <div class="navbar-logo">
                        <img :src="logoUrl" alt="Logo" class="logo-img" />
                        <span class="logo-text">智慧温室解决方案专家</span>
                    </div>
                    <el-button v-if="isMobile" class="menu-toggle" @click="showMenu = !showMenu">
                        <i :class="showMenu ? 'el-icon-close' : 'el-icon-menu'"></i>
                    </el-button>
                </div>
                <div class="navbar-right" :class="{ 'show': showMenu && isMobile }">
                    <el-menu-item v-for="item in navItems" :key="item.name" :index="item.route" class="menu-item">
                        {{ item.name }}
                    </el-menu-item>
                    <el-button type="primary" class="consult-btn" @click="showConsultDialog = true">
                        立即咨询
                    </el-button>
                </div>
            </el-menu>
        </div>

        <div class="banner-bg">
            <el-row :gutter="20" class="banner-content">
                <el-col class="text-section">
                    <p class="main-title">引领农业数字化转型</p>
                    <p class="sub-title">芯棚到家，您的智慧温室解决方案专家</p>
                    <p class="description">
                        依托人工智能、大数据、云计算等前沿科技，<br />
                        为农业提供全方位的智能化解决方案
                    </p>
                    <div class="button-group">
                        <el-button type="primary" class="more-btn"
                            @click="handleNavigation({ path: '/', hash: '#contact-section' })">预约演示</el-button>
                    </div>
                </el-col>
                <el-col class="logo-section">
                    <img src="@/assets/images/MainNavbar/banner-logo.png" alt="芯棚到家Logo" class="banner-logo" />
                </el-col>
            </el-row>
        </div>

        <div v-if="showConsultDialog" class="custom-dialog-overlay" @click="showConsultDialog = false">
            <div class="custom-dialog" @click.stop>
                <button class="dialog-close-btn" @click="showConsultDialog = false">×</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MainNavbar',
    data() {
        return {
            logoUrl: require('@/assets/images/MainNavbar/logo.png'),
            navItems: [
                { name: '首页', route: '/' },
                { name: '硬件产品', route: '/MainHardware' },
                { name: '软件产品', route: '/MainSoftware' },
                { name: '典型案例', route: '/MainTypicalcase' },
                { name: '关于我们', route: '/Mainabout' },
                { name: '联系我们', route: '/#contact-section' }
            ],
            activeIndex: '/',
            showConsultDialog: false,
            isMobile: false,
            showMenu: false
        }
    },
    watch: {
        $route(to) {
            this.activeIndex = [to.path, '/'].includes(to.path) ? to.fullPath : to.path;
        },
        '$window.innerWidth'() {
            this.checkScreenSize();
        }
    },
    mounted() {
        this.activeIndex = this.$route.path + (this.$route.hash || '');
        this.checkScreenSize();
        window.addEventListener('resize', this.checkScreenSize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize);
    },
    methods: {
        handleNavigation(route) {
            this.$router.push(route).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    console.error('路由跳转失败:', err);
                }
            });
            if (this.isMobile) {
                this.showMenu = false;
            }
        },
        checkScreenSize() {
            this.isMobile = window.innerWidth < 768;
            if (!this.isMobile) {
                this.showMenu = true;
            } else {
                this.showMenu = false;
            }
        }
    }
}
</script>

<style scoped>
.navbar-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 999;
    margin: 0;
    padding: 0;
}

.navbar-menu {
    display: flex;
    align-items: center;
    height: 80px;
    padding: 0 10px !important;
    width: 100%;
    box-sizing: border-box;
}

.navbar-menu>>>.el-menu {
    border-bottom: none;
    padding: 0;
}

.navbar-left {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
}

.navbar-logo {
    display: flex;
    align-items: center;
    gap: 12px;
}

.logo-img {
    height: 166px;
    width: 161px;
    object-fit: contain;
}

.logo-text {
    font-size: 22px;
    font-weight: 600;
    color: #333333;
    letter-spacing: 0.8px;
    white-space: nowrap;
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
}

.navbar-right {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-right: 20px;
    padding: 0;
    margin-left: auto;
}

.menu-item {
    font-weight: 500;
    transition: color 0.3s;
    padding: 0 5px !important;
    margin: 0 !important;
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-size: 18px;
}

.consult-btn {
    border-radius: 4px;
    padding: 0 20px;
    width: 112px;
    height: 40px;
    line-height: 40px;
    background-color: #2563eb;
    color: #ffffff;
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-size: 16px;
    font-weight: 500;
    border: none;
    margin: 0 !important;
}

.consult-btn:hover {
    background-color: #66b1ff;
}

.banner-bg {
    background-image: url('~@/assets/images/MainNavbar/banner.png');
    background-size: cover;
    background-position: center;
    padding: 20px;
    width: 100%;
    height: 462px;
}

.banner-content {
    width: 100%;
    margin: 0 auto;
    position: relative;
    z-index: 1;
}

.text-section {
    color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 120px;
    padding-left: 70px !important;
    box-sizing: border-box;
}

.logo-section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 20px 0;
}

.banner-logo {
    max-width: 497px;
    min-height: 80px;
    margin-top: -430px;
}

.main-title {
    font-size: 48px;
    font-weight: bold;
    font-family: Roboto;
    margin: 0;
}

.sub-title {
    font-size: 48px;
    font-weight: bold;
    font-family: Roboto;
    margin: 0;
}

.description {
    font-size: 20px;
    line-height: 1.6;
    font-family: Roboto;
    margin: 20px 0;
}

.button-group {
    display: flex;
    gap: 16px;
    /* margin-top: 30px; */
}

.more-btn {
    background-color: #2563eb;
    border-color: #2563eb;
    border-radius: 4px;
    padding: 10px 24px;
    width: 136px;
    height: 54px;
}

.demo-btn {
    background-color: #fff;
    border: 1px solid #ffffff;
    color: #2563eb;
    border-radius: 4px;
    padding: 10px 24px;
    width: 136px;
    height: 54px;
}

.el-button {
    font-size: 18px;
}

.demo-btn:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.custom-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.custom-dialog {
    width: 100%;
    max-width: 800px;
    height: auto;
    min-height: 400px;
    border-radius: 12px;
    background-image: url('~@/assets/images/MainNavbar/名片.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
}

.dialog-close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: rgba(0, 0, 0, 0.3);
    color: white;
    border: none;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    line-height: 1;
}

.dialog-close-btn:hover {
    background: rgba(0, 0, 0, 0.5);
}

.menu-toggle {
    display: none;
    margin-left: auto;
    background: transparent;
    border: none;
    font-size: 24px;
    color: #333;
}

@media (min-width: 768px) and (max-width: 1366px) {
    .logo-section {
        display: none;
    }

    .logo-text {
        display: none;
    }

    .section-header {
        margin-bottom: 40px;
    }

    .section-header h2 {
        font-size: 28px;
    }

    .main-title,
    .sub-title {
        font-size: 36px;
    }

    .description {
        font-size: 18px;
    }

    .banner-logo {
        max-width: 350px;
        margin-top: -350px;
    }
}

@media (max-width: 767px) {
    .menu-toggle {
        display: block;
    }

    .navbar-menu {
        height: auto;
        padding: 10px !important;
        flex-direction: column;
        align-items: flex-start;
    }

    .navbar-right {
        display: none;
        flex-direction: column;
        width: 100%;
        margin: 10px 0 0 0;
        padding: 10px 0;
        border-top: 1px solid #eee;
    }

    .navbar-right.show {
        display: flex !important;
    }

    .menu-item {
        width: 100%;
        text-align: left;
        padding: 10px 15px !important;
    }

    .consult-btn {
        width: 100%;
        margin-top: 10px !important;
    }

    .logo-img {
        height: 100px;
        width: 95px;
    }

    .logo-text {
        font-size: 16px;
    }

    .banner-bg {
        height: auto;
        padding: 40px 20px;

    }

    .text-section {
        padding: 120px 20px 0px !important;
    }

    .main-title,
    .sub-title {
        font-size: 28px;
    }

    .description {
        font-size: 16px;
    }

    /* .button-group {
        justify-content: center;
        margin-bottom: 30px;
    } */

    .logo-section {
        justify-content: center;
        display: none;

    }

    .banner-logo {
        max-width: 100%;
        margin-top: 0;
    }

    .custom-dialog {
        width: 100%;
        min-height: 300px;
    }
}

@media (min-width: 2000px) and (max-width: 3100px) {
    .navbar-container {
        padding: 0 50px;
    }

    .navbar-menu {
        height: 100px;
    }

    .logo-img {
        height: 200px;
        width: 190px;
    }

    .logo-text {
        font-size: 28px;
    }

    .menu-item {
        font-size: 22px;
        padding: 0 15px !important;
    }

    .consult-btn {
        width: 140px;
        height: 50px;
        font-size: 18px;
    }

    .banner-bg {
        height: 600px;
    }

    .main-title,
    .sub-title {
        font-size: 60px;
    }

    .description {
        font-size: 26px;
    }

    .more-btn {
        width: 160px;
        height: 60px;
        font-size: 20px;
    }

    .banner-logo {
        max-width: 600px;
        margin-top: -550px;
    }

    .custom-dialog {
        max-width: 1000px;
        min-height: 500px;
    }

    .dialog-close-btn {
        width: 40px;
        height: 40px;
        font-size: 24px;
    }
}
</style>